var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCableTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E39B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4997 28.1668H16.4997C16.1903 28.1668 15.8935 28.2897 15.6747 28.5085C15.4559 28.7273 15.333 29.0241 15.333 29.3335C15.333 29.6429 15.4559 29.9397 15.6747 30.1585C15.8935 30.3772 16.1903 30.5002 16.4997 30.5002H23.4997C23.8091 30.5002 24.1058 30.3772 24.3246 30.1585C24.5434 29.9397 24.6663 29.6429 24.6663 29.3335C24.6663 29.0241 24.5434 28.7273 24.3246 28.5085C24.1058 28.2897 23.8091 28.1668 23.4997 28.1668ZM29.333 11.8335H10.6663C10.0475 11.8335 9.45401 12.0793 9.01643 12.5169C8.57884 12.9545 8.33301 13.548 8.33301 14.1668V24.6668C8.33301 25.2857 8.57884 25.8792 9.01643 26.3167C9.45401 26.7543 10.0475 27.0002 10.6663 27.0002H29.333C29.9518 27.0002 30.5453 26.7543 30.9829 26.3167C31.4205 25.8792 31.6663 25.2857 31.6663 24.6668V14.1668C31.6663 13.548 31.4205 12.9545 30.9829 12.5169C30.5453 12.0793 29.9518 11.8335 29.333 11.8335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCableTv);
export default __webpack_public_path__ + "static/media/cable_tv.329d669f00eeb0d8a203ba235835e2e4.svg";
export { ForwardRef as ReactComponent };